document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = document.body.classList.toggle('nav-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-dropdown-toggle]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const item = button.closest('.has-dropdown');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.has-dropdown.is-open').forEach((openItem) => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const openButton = openItem.querySelector('[data-dropdown-toggle]');
          if (openButton) openButton.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-open', !isOpen);
      button.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-site-header]') && !event.target.closest('[data-search-overlay]')) {
      document.body.classList.remove('nav-open');
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      document.querySelectorAll('.has-dropdown.is-open').forEach((item) => {
        item.classList.remove('is-open');
        const button = item.querySelector('[data-dropdown-toggle]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }
  });

  const header = document.querySelector('[data-site-header]');
  const setScrolled = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
  };
  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  document.querySelectorAll('[data-hero-slideshow]').forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slideshow.querySelectorAll('[data-hero-dot]'));
    const prev = slideshow.querySelector('[data-hero-prev]');
    const next = slideshow.querySelector('[data-hero-next]');
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    const rotate = () => {
      if (slideshow.dataset.autoplay === 'true') {
        clearInterval(timer);
        timer = setInterval(() => show(index + 1), Number(slideshow.dataset.speed || 5000));
      }
    };
    prev && prev.addEventListener('click', () => { show(index - 1); rotate(); });
    next && next.addEventListener('click', () => { show(index + 1); rotate(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); rotate(); }));
    rotate();
  });

  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchResults = document.querySelector('[data-predictive-results]');
  const openSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    document.body.classList.add('search-open');
    setTimeout(() => searchInput && searchInput.focus(), 50);
  };
  const closeSearch = () => {
    if (!searchOverlay) return;
    document.body.classList.remove('search-open');
    searchOverlay.hidden = true;
  };
  document.querySelectorAll('[data-search-open]').forEach((button) => button.addEventListener('click', openSearch));
  document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));
  searchOverlay && searchOverlay.addEventListener('click', (event) => { if (event.target === searchOverlay) closeSearch(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSearch(); });

  let predictiveController;
  const updateSearchViewAll = (query) => {
    const viewAll = document.querySelector('[data-search-view-all]');
    if (!viewAll) return;
    const q = query ? `?q=${encodeURIComponent(query)}&type=product` : '?type=product';
    viewAll.href = `/search${q}`;
    viewAll.textContent = query ? `View all results for “${query}”` : 'View all products';
  };
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', async () => {
      const query = searchInput.value.trim();
      updateSearchViewAll(query);
      if (query.length < 2) {
        searchResults.innerHTML = '<div class="fs-search-empty-state"><strong>Start typing to discover products.</strong><span>Quick results will show products, collections, and a button to view every match.</span></div>';
        return;
      }
      try {
        if (predictiveController) predictiveController.abort();
        predictiveController = new AbortController();
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article&resources[limit]=12&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { signal: predictiveController.signal });
        if (!response.ok) return;
        const data = await response.json();
        const results = data.resources && data.resources.results ? data.resources.results : {};
        const products = results.products || [];
        const collections = results.collections || [];
        const productItems = products.slice(0, 8).map((product) => {
          const image = product.image || (product.featured_image && product.featured_image.url) || '';
          const vendor = product.vendor || product.type || 'Fragrance';
          const price = product.price || product.price_min || '';
          return `<a href="${product.url}" class="fs-predictive-product">${image ? `<img src="${image}" alt="">` : '<span class="fs-predictive-product__placeholder">FS</span>'}<span><strong>${escapeHtml(product.title)}</strong><small>${escapeHtml(vendor)}${price ? ` • ${escapeHtml(price)}` : ''}</small></span></a>`;
        });
        const collectionItems = collections.slice(0, 4).map((collection) => `<a href="${collection.url}" class="fs-predictive-chip">${escapeHtml(collection.title)}</a>`);
        const productsHtml = productItems.length ? `<div class="fs-predictive-group"><div class="fs-predictive-label">Matching products</div><div class="fs-predictive-product-grid">${productItems.join('')}</div></div>` : '';
        const collectionsHtml = collectionItems.length ? `<div class="fs-predictive-group"><div class="fs-predictive-label">Matching collections</div><div class="fs-predictive-chip-row">${collectionItems.join('')}</div></div>` : '';
        const viewAllHtml = `<a class="fs-predictive-view-all" href="/search?q=${encodeURIComponent(query)}&type=product">View all results for “${escapeHtml(query)}”</a>`;
        searchResults.innerHTML = productItems.length || collectionItems.length ? `${productsHtml}${collectionsHtml}${viewAllHtml}` : `<div class="fs-search-empty-state"><strong>No quick suggestions found.</strong><span>Press Enter or tap View all to run a full search.</span>${viewAllHtml}</div>`;
      } catch (error) {
        if (error.name !== 'AbortError') searchResults.innerHTML = '';
      }
    });
    updateSearchViewAll('');
  }

  const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]));
  const money = (cents) => {
    const amount = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(amount);
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD';
    try {
      return (amount / 100).toLocaleString(undefined, { style: 'currency', currency });
    } catch (error) {
      return '$' + (amount / 100).toFixed(2);
    }
  };

  const wishlistKey = 'fragnscentsWishlist';
  const legacyWishlistKey = 'fs_favorites';
  const getWishlist = () => {
    try {
      const current = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      if (Array.isArray(current) && current.length) return [...new Set(current.filter(Boolean))];
      const legacy = JSON.parse(localStorage.getItem(legacyWishlistKey) || '[]');
      if (Array.isArray(legacy) && legacy.length) {
        localStorage.setItem(wishlistKey, JSON.stringify([...new Set(legacy.filter(Boolean))]));
        return [...new Set(legacy.filter(Boolean))];
      }
    } catch (error) {}
    return [];
  };
  const setWishlist = (items) => {
    const clean = [...new Set((items || []).filter(Boolean))];
    localStorage.setItem(wishlistKey, JSON.stringify(clean));
    localStorage.setItem(legacyWishlistKey, JSON.stringify(clean));
    return clean;
  };
  const updateWishlistUI = () => {
    const items = getWishlist();
    document.querySelectorAll('[data-wishlist-handle]').forEach((button) => {
      const active = items.includes(button.dataset.wishlistHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (button.classList.contains('fs-product-favorite')) {
        button.textContent = active ? '♥ Saved to favorites' : '♡ Save to favorites';
      } else {
        button.textContent = active ? '♥' : '♡';
      }
    });
    document.querySelectorAll('[data-favorites-count]').forEach((el) => {
      el.textContent = String(items.length);
      el.hidden = items.length === 0;
      el.setAttribute('aria-hidden', items.length === 0 ? 'true' : 'false');
    });
  };
  const toggleWishlist = (handle) => {
    const items = getWishlist();
    const next = items.includes(handle) ? items.filter((item) => item !== handle) : [...items, handle];
    setWishlist(next);
    updateWishlistUI();
    return next;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-handle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.wishlistHandle;
    if (!handle) return;
    toggleWishlist(handle);
    renderFavoritesPage();
  });

  const productCardMarkup = (product, options = {}) => {
    const handle = product.handle;
    const title = escapeHtml(product.title);
    const url = product.url || `/products/${handle}`;
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const vendor = escapeHtml(product.vendor || '');
    const price = money(product.price || 0);
    const compare = Number(product.compare_at_price || 0);
    const current = Number(product.price || 0);
    const showCompare = compare > current && current > 0;
    const savings = showCompare ? Math.round(((compare - current) / compare) * 100) : 0;
    const remove = options.remove ? `<button class="fs-remove-favorite" type="button" data-wishlist-handle="${escapeHtml(handle)}">Remove</button>` : '';
    return `<div class="product-card" data-product-card>
      <a class="product-media" href="${url}" aria-label="${title}">${image ? `<img src="${image}" alt="${title}" loading="lazy">` : '<span>No image</span>'}</a>
      <div class="product-info">
        <a class="product-title" href="${url}">${title}</a>
        ${vendor ? `<div class="fs-product-vendor">${vendor}</div>` : ''}
        <div class="fs-price-wrap">
          <div class="fs-price-main"><span class="fs-price-current">${price}</span></div>
          ${showCompare ? `<div class="fs-price-market-row"><span class="fs-market-label">Retail</span><span class="fs-price-compare">${money(compare)}</span><span class="fs-save-badge">Save ${savings}%</span></div>` : ''}
        </div>
        ${remove || `<div class="fs-card-actions"><a class="fs-quick-add" href="${url}">View product</a><button class="fs-wishlist-btn" type="button" data-wishlist-handle="${escapeHtml(handle)}" aria-label="Toggle ${title} favorites">♡</button></div>`}
      </div>
    </div>`;
  };

  const fetchProductsByHandle = async (handles) => {
    const products = await Promise.all(handles.map((handle) => fetch(`/products/${encodeURIComponent(handle)}.js`).then((r) => r.ok ? r.json() : null).catch(() => null)));
    return products.filter(Boolean);
  };

  const renderFavoritesPage = async () => {
    const grid = document.querySelector('[data-favorites-grid]');
    const empty = document.querySelector('[data-favorites-empty]');
    const clear = document.querySelector('[data-favorites-clear]');
    if (!grid) return;
    const handles = getWishlist();
    grid.innerHTML = '';
    if (!handles.length) {
      if (empty) empty.hidden = false;
      if (clear) clear.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (clear) clear.hidden = false;
    grid.innerHTML = '<p class="fs-favorites-loading">Loading your favorites…</p>';
    const products = await fetchProductsByHandle(handles);
    const validHandles = products.map((product) => product.handle);
    if (validHandles.length !== handles.length) setWishlist(validHandles);
    grid.innerHTML = products.length ? products.map((product) => productCardMarkup(product, { remove: true })).join('') : '';
    if (empty) empty.hidden = products.length > 0;
    if (clear) clear.hidden = products.length === 0;
    updateWishlistUI();
  };

  document.querySelectorAll('[data-favorites-clear]').forEach((button) => {
    button.addEventListener('click', () => {
      setWishlist([]);
      updateWishlistUI();
      renderFavoritesPage();
    });
  });

  const currentProduct = document.querySelector('[data-current-product-handle]');
  if (currentProduct) {
    const handle = currentProduct.dataset.currentProductHandle;
    const viewed = JSON.parse(localStorage.getItem('fragnscentsRecentlyViewed') || '[]').filter((item) => item !== handle);
    viewed.unshift(handle);
    localStorage.setItem('fragnscentsRecentlyViewed', JSON.stringify(viewed.slice(0, 8)));
  }

  const recentGrid = document.querySelector('[data-recently-viewed-grid]');
  if (recentGrid) {
    const handles = JSON.parse(localStorage.getItem('fragnscentsRecentlyViewed') || '[]').slice(0, 4);
    if (!handles.length) {
      const section = document.querySelector('[data-recently-viewed-section]');
      if (section) section.style.display = 'none';
    } else {
      fetchProductsByHandle(handles).then((products) => {
        recentGrid.innerHTML = products.map((product) => productCardMarkup(product)).join('');
        updateWishlistUI();
      });
    }
  }

  updateWishlistUI();
  renderFavoritesPage();

  // Conversion/mobile optimization: sync mobile sticky Add to Cart with the selected variant and quantity.
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc) {
    const variantSelect = document.querySelector('#VariantSelector');
    const stickyVariantInput = stickyAtc.querySelector('[data-sticky-variant-id]');
    const stickyQtyInput = stickyAtc.querySelector('[data-sticky-quantity]');
    const qtyInput = document.querySelector('#Quantity');
    const stickySubmit = stickyAtc.querySelector('[data-sticky-submit]');
    const stickyPrice = stickyAtc.querySelector('[data-sticky-price]');

    const syncStickyAtc = () => {
      if (variantSelect && stickyVariantInput) {
        const selected = variantSelect.options[variantSelect.selectedIndex];
        stickyVariantInput.value = variantSelect.value;
        const unavailable = selected && (selected.disabled || selected.dataset.available === 'false');
        if (selected && selected.dataset.stickyPrice && stickyPrice) stickyPrice.textContent = selected.dataset.stickyPrice;
        if (stickySubmit) {
          stickySubmit.disabled = Boolean(unavailable);
          stickySubmit.textContent = unavailable ? 'Sold out' : 'Add to cart';
        }
      }
      if (qtyInput && stickyQtyInput) stickyQtyInput.value = qtyInput.value || '1';
    };

    if (variantSelect) variantSelect.addEventListener('change', syncStickyAtc);
    if (qtyInput) qtyInput.addEventListener('input', syncStickyAtc);
    syncStickyAtc();
  }

  // Mobile filter drawer and instant apply for checkbox/sort filters.
  document.querySelectorAll('[data-facets]').forEach((facets) => {
    const toggle = facets.querySelector('[data-filter-toggle]');
    const close = facets.querySelector('[data-filter-close]');
    const form = facets.querySelector('[data-filter-panel]');
    const setOpen = (open) => {
      facets.classList.toggle('is-open', open);
      document.body.classList.toggle('filters-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    if (toggle) toggle.addEventListener('click', () => setOpen(!facets.classList.contains('is-open')));
    if (close) close.addEventListener('click', () => setOpen(false));
    if (form) {
      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!target) return;
        if (target.matches('input[type="checkbox"], select[data-filter-sort]')) form.submit();
      });
    }
  });

  // Close mobile menu after a shopper taps a menu link.
  document.querySelectorAll('[data-primary-nav] a').forEach((link) => {
    link.addEventListener('click', () => {
      document.body.classList.remove('nav-open');
      const mobileToggleButton = document.querySelector('[data-mobile-nav-toggle]');
      if (mobileToggleButton) mobileToggleButton.setAttribute('aria-expanded', 'false');
    });
  });


});


// Keep honest low-stock messaging synchronized when a product variant changes.
document.addEventListener('change', function(event) {
  if (!event.target.matches('#VariantSelector')) return;
  var option = event.target.options[event.target.selectedIndex];
  var status = document.querySelector('.product-form [data-inventory-status]');
  var managed = option && option.dataset.inventoryManaged === 'true';
  var quantity = option ? parseInt(option.dataset.inventoryQuantity || '0', 10) : 0;
  var veryLow = 3;
  var low = 8;
  if (!status && managed && quantity > 0 && quantity <= low) {
    status = document.createElement('div');
    status.setAttribute('data-inventory-status','');
    var price = document.querySelector('.product-form .fs-price-wrap');
    if (price) price.insertAdjacentElement('afterend', status);
  }
  if (!status) return;
  if (!managed || quantity <= 0 || quantity > low) { status.style.display = 'none'; return; }
  status.style.display = 'flex';
  status.className = 'fs-inventory-message ' + (quantity <= veryLow ? 'fs-inventory-message--urgent' : 'fs-inventory-message--low');
  status.innerHTML = '<span class="fs-inventory-dot"></span>' + (quantity <= veryLow ? 'Only ' + quantity + ' left' : 'Low stock');
});
